export const corpSocarSite = "https://www.socarcorp.kr/";
export const irSite = "https://www.socarcorp.kr/ir/notice";
export const jobsSite = "https://www.socarcorp.kr/careers/jobs";
